import { render, staticRenderFns } from "./ParametrizacaoTemplate.vue?vue&type=template&id=e5b87c36"
import script from "./ParametrizacaoTemplate.vue?vue&type=script&lang=js"
export * from "./ParametrizacaoTemplate.vue?vue&type=script&lang=js"
import style0 from "./ParametrizacaoTemplate.vue?vue&type=style&index=0&id=e5b87c36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports